import { Component, ElementRef, input, viewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_SCHEDULER } from '@progress/kendo-angular-scheduler';
import { ControlWrapperComponent } from '@unity/forms/composed/control-wrapper/control-wrapper.component';

@Component({
  selector: 'unity-selector-recurrence-control',
  imports: [KENDO_SCHEDULER, ReactiveFormsModule, ControlWrapperComponent],
  templateUrl: './selector-recurrence-control.component.html',
  styleUrl: './selector-recurrence-control.component.scss',
})
export class SelectorRecurrenceControlComponent {
  public readonly $recurrenceEditorReference = viewChild.required('recurrenceEditor', { read: ElementRef });

  public readonly $control = input.required<FormControl>({ alias: 'control' });

  // DOM hack to remove the 'Never' endrule option
  private hideNeverRadioButton() {
    setTimeout(() => {
      const root = this.$recurrenceEditorReference().nativeElement.querySelector('kendo-recurrence-end-rule-editor');
      if (!root) {
        return;
      }

      const neverInput = root.querySelector('input[id^="k-endrule-never-"]') as HTMLInputElement;
      const untilInput = root.querySelector('input[id^="k-endrule-until-"]') as HTMLInputElement;
      untilInput.click();

      const neverLi = neverInput?.closest('li');
      if (neverLi) {
        neverLi.remove();
      }
    });
  }

  protected onRecurrenceEvent(event: MouseEvent) {
    event.preventDefault(); // Otherwise it triggers a form validation event
    const target = event.target as HTMLElement;
    const tagName = target.tagName.toLowerCase();
    const isModeButton = tagName === 'button' || tagName == 'span';
    if (isModeButton && event.isTrusted === true) {
      // A genuine click on something besides an input means a mode change, which resets the endrule radio, so intercept.
      this.hideNeverRadioButton();
    }
  }
}
